<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-10-16 09:26:51
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-12-05 18:00:51
 -->
<!--  -->
<template>
<div class="easyCruds avue-crud">
    <el-card  body-style="padding:0px 0.9375rem ;" shadow="never">
        <!-- start::表头 -->
        <div v-if="tableInfo.header && (tableInfo.header.title || tableInfo.header.slotName)" slot="header" class="easyCruds_head">
          <slot v-if="tableInfo.header.slotName" :name="tableInfo.header.slotName"></slot>
          <template v-else>
            <i v-if="booleanConversion(tableInfo.header.needIcon)" :class="(tableInfo.header.icon?tableInfo.header.icon: 'fa fa-table') + ' easyCruds_head_icon'" />
            <span class="easyCruds_head_title"> {{tableInfo.header.title}}</span>
          </template>
        </div>
        <!-- end::表头 -->
         <el-collapse-transition>
            <!-- start::条件筛选 -->
            <el-row v-if="searchShowFlag"  :gutter="2"  style="padding-top:0.5rem; ">
                <el-form
                  v-if="conditionColumn.length !==0"
                  :label-width=" (!tableInfo.table.conditionLabelWidth || tableInfo.table.conditionLabelWidth == 'auto')?'6.25rem':tableInfo.table.conditionLabelWidth * fighterScale"
                  :inline="false"  label-suffix=":"
                >
                    <el-col
                      v-for="(item,index)  in conditionColumn"
                      :key="index"
                      :xl="item.searchSpan_xl || tableInfo.table.search_xl || 6"
                      :lg="item.searchSpan_lg || tableInfo.table.search_lg || 8"
                      :md="item.searchSpan_md || tableInfo.table.search_md || 12"
                      :sm="item.searchSpan_sm || tableInfo.table.search_sm || 12"
                      :xs="24"
                    >
                        <el-form-item  :label="item.label||'Unnamed Field'" >
                            <slot v-if="item.searchSlotName"  :data="tableInfo.table.reloadConditions"  :name="item.searchSlotName"></slot>
                            <component
                            v-else
                            :is="getSearchType(item.type, item.component)"
                            :filterable="item.filterable === false?false:true"
                            :clearable="item.clearable"
                            :change="searchItemChange"
                            :column="item"
                            :dataType="item.dataType"
                            :format="item.format"
                            :multiple="item.multiple"
                            :label="item.label"
                            :minRows="item.minRows"
                            :maxRows="item.maxRows"
                            :precision="item.precision"
                            :prop="item.prop"
                            :placeholder="getPlaceholder(item)"
                            :tip="item.tip"
                            :type=" getType(item.type)"
                            :display="item.display"
                            :valueDefault="item.valueDefault"
                            :tags='true'
                            :value-format="item.valueFormat"
                            :min="item.min"
                            :max="item.max"
                            :minlength="item.minlength"
                            :maxlength="item.maxlength"
                            size="medium"
                            :append="item.append"
                            :dic="item.dicData"
                            :border="item.border"
                            :prepend="item.prepend"
                            :showWordLimit="item.showWordLimit"
                            :controls-position="item.controlsPosition"
                            v-model="tableInfo.table.reloadConditions[item.prop]"
                            />
                        </el-form-item >
                    </el-col>
                    <el-col :xl="tableInfo.table.search_xl || 6" :lg="tableInfo.table.search_lg || 8" :md="tableInfo.table.search_md || 12" :sm="tableInfo.table.search_sm || 24"  :xs="24">
                        <el-form-item  >
                            <el-button @click="reload" type="primary" icon="el-icon-search"  size="small">搜索</el-button>
                            <el-button @click="resetForm" icon="el-icon-delete"  size="small">清空</el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
        </el-collapse-transition>
        <!-- end::条件筛选 -->
        <div  class="avue-crud__menu" v-if="tableInfo.buttonSetting.allowAdd ||(tableInfo.buttonSetting.allowDelete && tableInfo.buttonSetting.allowMoreDelete) ||arrayConversion(tableInfo.buttonSetting.left) ||arrayConversion(tableInfo.buttonSetting.right) ">
            <div class="avue-crud__left">
                <el-button v-if="tableInfo.buttonSetting.allowAdd" icon="el-icon-plus"   type="primary" size="small" @click="addRow"> 新增 </el-button>
                <el-button v-if="tableInfo.buttonSetting.allowDelete && booleanConversion(tableInfo.buttonSetting.allowMoreDelete)" icon="el-icon-delete" type="danger"  size="small" @click="deleteRows()"> 删除 </el-button>
                <template v-if="arrayConversion(tableInfo.buttonSetting.left) ">
                    <el-button v-for="(item,index) in  tableInfo.buttonSetting.left"  :key="index" :type="item.type||'primary'" :icon="item.icon" size="small" @click="triggerEvent(item.clickEvent)"> {{item.title||'Unnamed button'}} </el-button>
                </template>
            </div>
            <div class="avue-crud__right">
                <el-tooltip  effect="light" content="刷新" placement="bottom">
                    <el-button v-if="booleanConversion(tableInfo.buttonSetting.allowRefresh)" @click="reload" icon="el-icon-refresh"   size="small" circle></el-button>
                </el-tooltip>
                <el-tooltip  effect="light" content="搜索" placement="bottom">
                    <el-button @click="searchShow" v-if="conditionColumn.length !== 0" icon="el-icon-search" size="small" circle></el-button>
                </el-tooltip>
                <template v-if="arrayConversion(tableInfo.buttonSetting.right)">
                   <el-tooltip v-for="(item,index) in  tableInfo.buttonSetting.right"  :key="index" effect="light" :content="item.title" placement="bottom">
                       <el-button  :type="item.type||'primary'" :circle="item.shape || circle" :icon="item.icon" size="small" @click="triggerEvent(item.clickEvent)">{{item.title}}</el-button>
                    </el-tooltip>
                </template>

            </div>
        </div>
          <!-- start::表单数据渲染区域 -->
      <el-table
       :indent="18"
        @row-click="clickRow"
        row-key="id"
        :lazy="true"
        :load="load"
        ref='table'
        size='medium'
        @sort-change="sortChange"
        tooltip-effect="light"
        :row-style="tableInfo.table.rowStyle"
        :cell-class-name="tableInfo.table.cellClassName"
        :cell-style-name="tableInfo.table.cellStyle"
        :header-row-class-name="tableInfo.table.headerRowClassName"
        :header-row-style="tableInfo.table.headerRowStyle"
        v-loading="tableInfo.table.loading"
        element-loading-text="拼命加载中..."
        :stripe="booleanConversion(tableInfo.table.stripe)"
        :highlight-current-row="true"
        :data="tableInfo.table.tableData"
        :max-height="maxHeight"
        style="margin-top:8px;"
        :border="true"
      >
      <!-- 空插槽 border -->
      <template slot="empty">
          <avue-empty></avue-empty>
      </template>
      <!-- 多选列 -->
        <el-table-column v-if="booleanConversion(tableInfo.table.selection)" align="center"  fixed="left" width="50" type="selection" prop="rowid" ></el-table-column>
        <el-table-column v-if="booleanConversion(tableInfo.table.index)" label="序号" align="center" width="50" fixed="left">
              <template slot-scope="scope"><span>{{getColumnIndex(scope.$index)}} </span></template>
        </el-table-column>
        <template v-if="arrayConversion(tableInfo.table.columns)" >
          <template  v-for="(item,index) in tableInfo.table.columns">
            <el-table-column
              :key="index"
              v-if="booleanConversion(item.showInTable) "
              :align="item.align || 'center'"
              :header-align="tableInfo.table.headerAlign || 'center'"
              show-overflow-tooltip
              :prop="item.prop"
              :label="item.label"
              :fixed="item.fixed"
              :sortable="item.sortable"
              :width="item.width * fighterScale"
            >
            <template slot-scope="scope">
                  <!-- 如果该列配置中 slot 为true  向外给出插槽-->
                  <slot v-if="item.slotName" :index="scope.$index"  :row="scope.row" :name="item.slotName"></slot>
                  <template v-else>
                      <el-tag
                      v-if="item.isTag"
                      :type="typeof item.tagFilter === 'function'?item.tagFilter(scope.row[item.prop],scope.row).type:''"
                      >
                      {{ typeof item.tagFilter === 'function'?item.tagFilter(scope.row[item.prop],scope.row).data:scope.row[item.prop] }}
                      </el-tag>
                      <template v-else>
                          {{typeof item.dataFilter === 'function'?item.dataFilter(scope.row[item.prop],scope.row):scope.row[item.prop]}}
                      </template>
                  </template>
            </template>
          </el-table-column>
          </template>
        </template>
        <!-- note::循环操作 -->
        <el-table-column
          align="center"
          fixed="right"
          label="操作"
          v-if="(tableInfo.table.operation && arrayConversion(tableInfo.table.operation.operations))
          || (tableInfo.table.operation && tableInfo.table.operation.slotName)
          || tableInfo.buttonSetting.allowView
          || tableInfo.buttonSetting.allowEdit
          || tableInfo.buttonSetting.allowDelete"
          :width="tableInfo.table.operation && tableInfo.table.operation.width ? tableInfo.table.operation.width : '' "
        >
          <template slot-scope="scope">
              <!-- 如果操作列需要插槽展示,这里变对外抛出插槽 -->
              <slot v-if="tableInfo.table.operation && tableInfo.table.operation.slotName" :index="scope.$index" :name="tableInfo.table.operation.slotName" :row="scope.row"></slot>
             <template v-else>
               <el-button size="small" v-if="booleanConversion(tableInfo.buttonSetting.allowView)" type="text" @click="viewRow(scope.row)">
                    <span >查看</span>
                </el-button>
                <el-button  size="small" v-if="booleanConversion(tableInfo.buttonSetting.allowEdit)" type="text" @click="editRow(scope.row)">
                    <span style="color:#9f8bea">编辑</span>
                </el-button>
                <el-button size="small" v-if="booleanConversion(tableInfo.buttonSetting.allowDelete)" type="text" @click="deleteRows(scope.row)">
                    <span style="color:#e78ab0">删除</span>
                </el-button>
                <!-- 开始循环自定义的操作 -->
                <template v-if="tableInfo.table.operation && arrayConversion(tableInfo.table.operation.operations)">
                  <el-button  size="small"
                      v-for="(item,index) in tableInfo.table.operation.operations"
                      :key="index"
                      type="text"
                      :icon="item.icon"
                      @click="triggerEvent(item.clickEvent,scope.$index, scope.row)"
                      >
                      <span :style="{color:item.color}">{{ typeof item.title === 'function'?item.title(scope.row):item.title }}</span>
                  </el-button>
              </template>
             </template>
          </template>
        </el-table-column>
      </el-table>
      <nav v-if="tableInfo.table && tableInfo.table.paging"  style="text-align: right;margin:0.625rem 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="tableInfo.table.paging.currentPage || 1"
          :page-sizes="tableInfo.table.paging.pageSizes || [15, 25, 35, 45]"
          :page-size="tableInfo.table.paging.pageSize || 15"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableInfo.table.paging.total || 0 "
        ></el-pagination>
      </nav>
    </el-card>

    <!-- 2019-11-17 重构  合并新增、查看、编辑框 -->
    <!-- 如果存在 新增、编辑、查看任何一选项为真, 则改模块显示 -->
      <easyForm v-if="tableInfo.buttonSetting.allowAdd || tableInfo.buttonSetting.allowView || tableInfo.buttonSetting.allowEdit"
       :easyFormInfo="easyFormInfo" @unifiedCaptureFunction="unifiedCaptureFunction"  >
        <!-- 字段插槽 -->
         <template slot-scope="{easyFormInfo,disabled,data,label,prop}"
                v-for="(item) in tableInfo.table.columns"
                :slot="item.prop">
        <slot :easyFormInfo="easyFormInfo"
              :disabled="disabled"
              :data="data"
               :label="label"
               :prop="prop"
              :name="item.prop+'Form'"
              v-if="item.formslot"></slot>
      </template>
        <!-- <template  >
          <div  v-if="item.formslot" :slot="item.prop" slot-scope="{value,disabled,data,label}" :key="index">
              <slot    :name="item.prop" :value="value" :disabled="disabled" :data="data" :label="label"  ></slot>
          </div>
        </template> -->
        <template   slot="easyCrudsInternal" slot-scope="{data}" >
          <slot    :data="data"  name="formSlot"></slot>
        </template>
      </easyForm>

</div>
</template>

<script>

import easyForm from '../easyForm/easyForm'
import { deepClone } from '@/framework/util/util.js'
export default {
  props: {
    tableInfo: {
      type: Object,
      required: true,
      validator: function(tableInfo) {
        let logError = function(messege) {
          console.log(`%c easyCruds组件Error:缺失 ${messege} 参数`, 'color:red;font-size:15px;text-shadow: 0px 0px 5px green;')
          return false
        }
        if (!tableInfo) {
          return logError('tableInfo')
        } else if (!tableInfo.buttonSetting) {
          return logError('tableInfo.buttonSetting')
        } else if (!tableInfo.table) {
          return logError('tableInfo.table')
        } else if (!tableInfo.table.reloadConditions) {
          return logError('tableInfo.table.reloadConditions')
        } else {
          return true
        }
      }
    }
  },

  data() {
    return {
      fighterScale: 1, // 当前屏幕与标准屏幕比值
      /** 搜索栏目显示控制 */
      searchShowFlag: true,
      /** 弹出表格控制 */
      easyFormInfo: {
        header: {
          title: '未初始化',
          show: false,
          width: '60%',
          marginTop: '5vh',
          CloseOnClickModal: false,
          fullscreen: false
        },
        data: {},
        form: {
          labelWidth: this.tableInfo.table.labelWidth,
          slotName: 'easyCrudsInternal',
          formItems: []
        },
        formButton: []
      }

    }
  },
  created() {
    this.fighterScale = window.fighterScale
  },
  components: { easyForm },
  computed: {
    maxHeight: function() {
      let maxHeight = null
      if (this.tableInfo?.table?.maxHeight) {
        maxHeight = this.tableInfo.table.maxHeight * this.fighterScale
      }
      if (this.tableInfo?.table?.height) {
        maxHeight = this.tableInfo.table.height * this.fighterScale
      }
      return maxHeight
    },
    conditionColumn: function() {
      return this.tableInfo.table.columns.filter(i => i.isSearchCondition === true)
    }
  },
  methods: {
    unifiedCaptureFunction: function(data, note, setting, oldData) {
      this.easyFormInfo.formButton.forEach(item => this.$set(item, 'loading', true))
      this.triggerEvent(note.clickEvent, data, () => {
        this.easyFormInfo.header.show = false
        this.easyFormInfo.formButton.forEach(item => this.$set(item, 'loading', false))
      }, () => {
        this.easyFormInfo.formButton.forEach(item => this.$set(item, 'loading', false))
      }, note.scene, setting, oldData)
    },
    /** 新增函数 */
    addRow: function() {
      /**
     * 表格扩展按钮处理函数 此处考虑还是向外给出 done errDone 函数
     * @parms  data  表单数据
     * @parms  note  备注值，该处可能直接为事件
     */
      var callback = (data) => {
        /** 这里需要装配 新增框需要的配置  */
        /** 新增默认数据装配  */
        this.easyFormInfo.data = (data) || {}
        this.easyFormInfo.header.show = true
      }

      // 扩展 2020 /05/07 by jie.zhang  依照需求，配置抛出可更改
      /** 表格基础信息配置 */
      this.easyFormInfo.header.title = this.tableInfo.buttonSetting.addText || '新增'
      this.easyFormInfo.header.width = this.tableInfo.buttonSetting.addWidth || '60%'
      this.easyFormInfo.header.marginTop = this.tableInfo.buttonSetting.addMarginTop || '5vh'
      this.easyFormInfo.header.CloseOnClickModal = this.tableInfo.buttonSetting.addCloseOnClickModal || false
      this.easyFormInfo.header.fullscreen = this.tableInfo.buttonSetting.addFullscreen || false
      /** 添加列 */
      let columns = deepClone(this.tableInfo.table.columns)
      let formItems = []
      columns.forEach((item, index) => {
        /** 是否显示 */
        if (item.view && item.view.length === 3 ? item.view[0] : true) {
          item.disabled = item.disabled && item.disabled.length === 3 ? item.disabled[0] : false
          formItems.push(item)
        }
      })
      this.easyFormInfo.form.formItems = formItems
      if (this.arrayConversion(this.tableInfo.buttonSetting.addButtonArray)) {
        /** 添加按钮 */
        let formButton = []
        this.tableInfo.buttonSetting.addButtonArray.forEach(item => {
          if (!item.note) { item.note = {} }
          if (!item.note.clickEvent) {
            item.note.clickEvent = item.clickEvent
            item.clickEvent = 'unifiedCaptureFunction'
            item.note.scene = 'ADD'
          }
          formButton.push(item)
        })
        this.easyFormInfo.formButton = formButton
      } else {
        this.easyFormInfo.formButton = []
      }

      if (this.tableInfo.buttonSetting.beforeAddFunctionName) {
        this.triggerEvent(this.tableInfo.buttonSetting.beforeAddFunctionName, null, 'ADD', callback, this.easyFormInfo)
      } else {
        callback()
      }
    },
    /** 编辑某行 */
    editRow: function(row) {
      var callback = (data) => {
        this.easyFormInfo.data = (data) || deepClone(row)

        this.easyFormInfo.header.show = true
      }
      /** 表格基础信息配置 */
      this.easyFormInfo.header.title = this.tableInfo.buttonSetting.editText || '编辑'
      this.easyFormInfo.header.width = this.tableInfo.buttonSetting.editWidth || '60%'
      this.easyFormInfo.header.marginTop = this.tableInfo.buttonSetting.editMarginTop || '5vh'
      this.easyFormInfo.header.CloseOnClickModal = this.tableInfo.buttonSetting.editCloseOnClickModal || false
      this.easyFormInfo.header.fullscreen = this.tableInfo.buttonSetting.editFullscreen || false
      /** 添加列 */
      let columns = deepClone(this.tableInfo.table.columns)
      let formItems = []
      columns.forEach((item, index) => {
        /** 是否显示 */
        if (item.view && item.view.length === 3 ? item.view[2] : true) {
          item.disabled = item.disabled && item.disabled.length === 3 ? item.disabled[2] : false
          formItems.push(item)
        }
      })
      this.easyFormInfo.form.formItems = formItems

      if (this.arrayConversion(this.tableInfo.buttonSetting.editButtonArray)) {
        /** 添加按钮 */
        let formButton = []
        this.tableInfo.buttonSetting.editButtonArray.forEach(item => {
          if (!item.note) { item.note = {} }
          if (!item.note.clickEvent) {
            item.note.clickEvent = item.clickEvent
            item.note.scene = 'EDIT'
            item.clickEvent = 'unifiedCaptureFunction'
          }
          formButton.push(item)
        })
        this.easyFormInfo.formButton = formButton
      } else {
        this.easyFormInfo.formButton = []
      }
      if (this.tableInfo.buttonSetting.beforeEditFunctionName) {
        this.triggerEvent(this.tableInfo.buttonSetting.beforeEditFunctionName, deepClone(row), 'EDIT', callback, this.easyFormInfo)
      } else {
        callback()
      }
    },
    /** 查看某一行数据 */
    viewRow: function(row) {
      var callback = (data) => {
        this.easyFormInfo.data = (data) || deepClone(row)

        this.easyFormInfo.header.show = true
      }
      /** 表格基础信息配置 */
      this.easyFormInfo.header.title = this.tableInfo.buttonSetting.viewText || '查看'
      this.easyFormInfo.header.width = this.tableInfo.buttonSetting.viewWidth || '60%'
      this.easyFormInfo.header.marginTop = this.tableInfo.buttonSetting.viewMarginTop || '5vh'
      this.easyFormInfo.header.CloseOnClickModal = this.tableInfo.buttonSetting.viewCloseOnClickModal || false
      this.easyFormInfo.header.fullscreen = this.tableInfo.buttonSetting.viewFullscreen || false
      /** 添加列 */
      let columns = deepClone(this.tableInfo.table.columns)
      let formItems = []
      columns.forEach((item, index) => {
        /** 是否显示 */
        if (item.view && item.view.length === 3 ? item.view[1] : true) {
          item.disabled = item.disabled && item.disabled.length === 3 ? item.disabled[1] : true
          formItems.push(item)
        }
      })
      this.easyFormInfo.form.formItems = formItems
      if (this.arrayConversion(this.tableInfo.buttonSetting.viewButtonArray)) {
        /** 添加按钮 */
        let formButton = []
        this.tableInfo.buttonSetting.viewButtonArray.forEach(item => {
          if (!item.note) { item.note = {} }
          if (!item.note.clickEvent) {
            item.note.clickEvent = item.clickEvent
            item.note.scene = 'VIEW'
            item.clickEvent = 'unifiedCaptureFunction'
          }
          formButton.push(item)
        })
        this.easyFormInfo.formButton = formButton
      } else {
        this.easyFormInfo.formButton = []
      }
      if (this.tableInfo.buttonSetting.beforeViewFunctionName) {
        this.triggerEvent(this.tableInfo.buttonSetting.beforeViewFunctionName, deepClone(row), 'VIEW', callback, this.easyFormInfo)
      } else {
        callback()
      }
    },
    /**
     * 删除函数
     */
    deleteRows: function(row, index) {
      var deleteList = []
      /** 判断是多行删除还是单行删除 */
      if (row) {
        deleteList.push(row)
      } else {
        deleteList = this.getSelectedRows()
        if (deleteList.length === 0) {
          return this.$message({ message: '请选中一条记录再操作哟。', type: 'warning' })
        }
      }
      /** 开始执行删除    **  先询问 */
      this.$confirm('删除后不可恢复, 是否继续?', '提示', { cancelButtonText: '取消', confirmButtonText: '确定', type: 'warning' }).then(() => {
        this.triggerEvent(this.tableInfo.buttonSetting.deleteFunctionName || 'deleteRows', deleteList, index)
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' })
      })
    },
    /** 绝对 false 检测 */
    booleanConversion: function(value) {
      return value !== false
    },
    /** 检查是否数组,且含有一项元素 */
    arrayConversion: function(value) {
      return Object.prototype.toString.call(value) === '[object Array]' && value.length > 0
    },
    /** 从表格配置中,提取出允许作为搜索条件的元素 */
    getConditionColumn(flag) {
      if (!this.easy_ConditionColumn) {
        this.easy_ConditionColumn = this.tableInfo.table.columns.filter(i => i.isSearchCondition === true)
      }
      if (flag) {
        return this.easy_ConditionColumn.length !== 0
      } else {
        return this.easy_ConditionColumn
      }
    },
    /** 搜索框获取动态组件 */
    getSearchType: function(type, component) {
      let result = 'input'
      if (['select', 'radio', 'checkbox', 'switch'].includes(type)) {
        result = 'select'
      } else if (['time', 'timerange'].includes(type)) {
        result = 'time'
      } else if ([
        'dates',
        'date',
        'datetime',
        'datetimerange',
        'daterange',
        'week',
        'month',
        'monthrange',
        'dategrpup',
        'year'
      ].includes(type)) {
        result = 'date'
      } else if (['cascader'].includes(type)) {
        result = 'cascader'
      } else if (['number'].includes(type)) {
        result = 'input-number'
      }
      return 'avue-' + result
    },
    /** 获取输入框类型 */
    getType: function(type) {
      if (type === 'textarea') {
        return 'input'
      } else {
        return type
      }
    },
    /**
     * @description 获取提示字符串
     * @param {Object} column 列配置
     */
    getPlaceholder(column) {
      if (column.placeholder) {
        return column.placeholder
      }
      const label = column.label
      if (['select', 'checkbox', 'radio', 'color', 'date', 'time'].includes(column.type)) {
        return `请选择${label}`
      } else {
        return `请输入${label}`
      }
    },
    /**
     * @description 获取重载条件,重载表中数据
     */
    reload: function() {
      this.$emit(this.tableInfo.table.reload, this.getReloadConditions())
    },
    /** 获取表格重载条件  2019-11-15 第 { 8 } 次重构 */
    getReloadConditions: function() {
      let validityCheck = function(value) {
        if (Object.prototype.toString.call(value) === '[object String]') {
          return value !== ''
        } else if (Object.prototype.toString.call(value) === '[object Number]') {
          return true
        } else if (Object.prototype.toString.call(value) === '[object Boolean]') {
          return true
        } else if (Object.prototype.toString.call(value) === '[object Array]') {
          return true
        } else if (Object.prototype.toString.call(value) === '[object Object]') {
          return true
        } else if (Object.prototype.toString.call(value) === '[object Date]') {
          return true
        } else {
          return false
        }
      }
      let reloadConditions = this.tableInfo.table.reloadConditions
      let retult = {}
      for (let conditionItem in reloadConditions) {
        if (validityCheck(reloadConditions[conditionItem])) {
          retult[conditionItem] = reloadConditions[conditionItem]
        }
      }
      /** 在存在 paging 且 paging 合法 的情况下 获取 paging 条件集合 */
      if (
        this.tableInfo.table.paging &&
        this.tableInfo.table.paging.currentPage &&
        this.tableInfo.table.paging.pageSize
      ) {
        retult['pageNum'] = this.tableInfo.table.paging.currentPage
        retult['pageSize'] = this.tableInfo.table.paging.pageSize
      }
      /** 获取tableInfo 中 serverSort 字段。 */
      if (
        this.tableInfo.table['serverSort'] &&
        this.tableInfo.table['serverSort'].sidx &&
        this.tableInfo.table['serverSort'].sord
      ) {
        retult['sidx'] = this.tableInfo.table['serverSort'].sidx
        retult['sord'] = this.tableInfo.table['serverSort'].sord
      }
      return retult
    },
    /** 重置表格筛选函数 */
    resetForm: function() {
      let reloadConditions = this.tableInfo.table.reloadConditions
      let result = {}
      for (let conditionItem in reloadConditions) {
        if (Object.prototype.toString.call(reloadConditions[conditionItem]) === '[object Array]') {
          result[conditionItem] = []
        }
      }
      /** 清除表格条件 */
      this.tableInfo.table.reloadConditions = result

      if (this.tableInfo.buttonSetting.resetFunctionName) {
        this.triggerEvent(this.tableInfo.buttonSetting.resetFunctionName, result)
      }
      /** 修改当前页码*/
      this.resetCurrentPage()
    },
    /**
     * 搜索框条件改变时
     */
    searchItemChange: function(data) {
      if (data && data.value !== undefined) {
        this.resetCurrentPage()
        if (data.column.searchChangeFunction) {
          this.triggerEvent(data.column.searchChangeFunction, data, this.tableInfo.table.reloadConditions)
        } else if (data.column.searchChange) {
          typeof data.column.searchChange === 'function' && data.column.searchChange(data, this.tableInfo.table.reloadConditions)
        }
      }
    },
    /**
     * @description 在重载条件改变后,需要重置当前页.避免请求数据时,请求页数超最大页.
     */
    resetCurrentPage: function() {
      this.tableInfo.table.paging && this.tableInfo.table.paging.currentPage && (this.tableInfo.table.paging.currentPage = 1)
    },
    /** 父组件事件触发器  默认5参数  x为事件 */
    triggerEvent: function(x, y, z, a, b, c, d, e, f, g) {
      this.$emit(x, y, z, a, b, c, d, e, f, g)
    },
    /** 获取行号 */
    getColumnIndex: function(index) {
      if (this.tableInfo.table.paging && this.tableInfo.table.paging.currentPage && this.tableInfo.table.paging.pageSize) {
        return ((this.tableInfo.table.paging.currentPage - 1) * this.tableInfo.table.paging.pageSize) + index + 1
      } else {
        return index + 1
      }
    },
    /**
     * @description 返回表格中选中状态的数据,为避免异常发生,如果获取到为空,则返回空数组
     */
    getSelectedRows: function() {
      return this.$refs.table.selection || []
    },
    /**
     * @description 单击某行数据触发的函数,如果该行lable不为“操作”,则选中该行
     */
    clickRow(row, event, column) {
      event.label !== '操作' && this.$refs.table.toggleRowSelection(row)
    },
    /**
    * @description 获取配置项中columnName列的setingName的配置
    * @param {String} columnName 列名称(prop)
    * @param {String} setingName 配置项名称
    */
    getColumnSeting: function(columnName, setingName) {
      let temp = this.tableInfo.table.columns.filter(item => item.prop === columnName)
      return temp.length === 1 ? temp[0][setingName] : { warning: '执行错误,未找到或找到多个:' + columnName }
    },
    /**
    * @description 设置配置项中columnName列的setingName属性为steingValue
    * @param {String} columnName 列名称(prop)
    * @param {String} setingName 配置项名称
    * @param {Object} steingValue 配置的数据
    */
    setColumnSeting: function(columnName, setingName, steingValue) {
      let temp = this.tableInfo.table.columns.filter(item => item.prop === columnName)
      return temp.length === 1 ? this.$set(temp[0], setingName, steingValue) : { warning: '执行错误,未找到或找到多个:' + columnName }
    },
    /** 排序改变事件 */
    sortChange: function({ column, prop, order }) {
      this.tableInfo.table['serverSort'] = {}
      if (this.getColumnSeting(prop, 'serverSort') === true) {
        this.tableInfo.table['serverSort']['sidx'] = prop
        this.tableInfo.table['serverSort']['sord'] = order
        this.reload()
      }
    },
    /**
     * @description 页大小改变后触发该事件
     * @param {number} pageSize 改变后的页大小
     */
    handleSizeChange: function(pageSize) {
      (this.tableInfo.table.paging['pageSize'] = pageSize) && this.reload()
    },
    /**
     * @description 页改变后触发该事件
     * @param {number} currentPage 改变后的页
     */
    handleCurrentChange: function(currentPage) {
      (this.tableInfo.table.paging['currentPage'] = currentPage) && this.reload()
    },
    /**
     * 隐藏显示搜索条件
     */
    searchShow: function() {
      this.searchShowFlag = !this.searchShowFlag
    },
    /** shu1 */
    load(tree, treeNode, resolve) {
      this.triggerEvent('load', tree, treeNode, resolve)
    }

  }
}
</script>
<style lang='scss'>
.easyCruds {
    .el-card__header {
        padding: 0.9375rem 1.25rem;
    }
    .el-form-item {
        margin-bottom: 0.3125rem;
    }
}
</style>
<style lang='scss' scoped>
.easyCruds {
    &_head {
        &_icon {
            color: #409EFF
        }
        &_title {
            text-indent: 2px;
            color: #409EFF;
        }
    }
}
/*
.avue-crud__menu{
    margin-top: 5px;
}
.avue-crud__left ,.avue-crud__right{
    line-height: 40px;
}*/

</style>
